import { render, staticRenderFns } from "./FinalRecap.vue?vue&type=template&id=3964da91&"
import script from "./FinalRecap.vue?vue&type=script&lang=js&"
export * from "./FinalRecap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports